import { motion } from 'framer-motion';
import { getLoginLink } from '../config/externalLinks';

const navLinks = [
  { label: 'Inicio', href: '#inicio' },
  { label: 'Funcionalidades', href: '#funcionalidades' },
  { label: 'Premium', href: '#premium' },
] as const;

export function Navbar() {
  const loginLink = getLoginLink();

  return (
    <motion.header
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
      className="sticky top-0 z-30 border-b border-brand-border/70 bg-brand-deep/85 backdrop-blur"
    >
      <nav className="mx-auto flex w-full max-w-6xl items-center gap-3 px-4 py-3 sm:px-6 lg:gap-4 lg:px-8 lg:py-4">
        <a href="#inicio" className="shrink-0">
          <img
            src={`${process.env.PUBLIC_URL}/logo_protorneos-15.svg`}
            alt="Protorneos"
            className="h-8 w-auto sm:h-9"
          />
        </a>
        <ul className="flex flex-1 items-center justify-center gap-6 text-sm text-zinc-300 sm:gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a href={link.href} className="transition hover:text-brand-yellow">
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <a
          href={loginLink}
          target="_blank"
          rel="noopener noreferrer"
          className="action-btn shrink-0 bg-brand-yellow px-3 py-2 text-xs text-black hover:bg-transparent hover:text-brand-yellow sm:px-5 sm:py-2.5 sm:text-sm"
        >
          Iniciar sesión
        </a>
      </nav>
    </motion.header>
  );
}
